// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__BkmPw","title":"style__title__PFMsV","description":"style__description__ZKz4q","component":"style__component__cU-Oj"};